export default {
  letsPlayBrand: "Jouons.",
  "courtSize": {"single": "Célibataire", "double": "Double"},
  "unfinishedColumn": "Partiel",
  "rejectedSave": "Votre club n'a pas pu accepter ces changements. Vos actions locales sont tenues. Révisez le dernier score ou téléchargez vos actions avant de les supprimer.",
  "unverifiedSave": "Nous ne pouvions pas vérifier l'épargne. Vos actions locales sont conservées. Révisez le dernier score ou téléchargez vos actions avant de les jeter.",

  "finishQuestion": "Finir la session ?",
  "saveFinish": "Enregistrer et terminer",
  "unfinishedOutcome": "Session inachevée",
  "tiedOutcome": "Niveau des scores",
  "finishedOutcome": "Session terminée",
  "savingResult": "Sauvegardé sur cet appareil · Enregistrer dans votre club...",
  "offlineResult": "Sauvegardé sur ce dispositif · Se synchronisera quand il est connecté",
  "syncedResult": "Sauvegardé dans votre club",
  "momentWaiting": "Votre moment s'ouvrira une fois que l'épargne sera terminée...",
  "saveFailed": "Vous ne pouvez pas synchroniser. Votre score est maintenu sur cet appareil.",

  "deleteChanged": "Cette session a changé avant de pouvoir être supprimée. Résumez-le pour examiner les dernières notes, puis essayez de supprimer à nouveau.",
  "moreActions": "Plus encore",
  "deleteSession": "Supprimer la session",
  "deleteNote": "Retirer cette session de Continuer à jouer? Les scores et l'historique des vérifications sont conservés. Les réservations de courts sont inchangées.",
  "deletePending": "Cette session a des scores non synchronisés ou une ébauche locale. Rappelez-le pour synchroniser ou examiner et supprimer ce travail avant de supprimer.",
  "deleting": "Deleting...",
  "live": "En direct",
  "completedSet": "manche complet",
  "completedGame": "Jeu complet",
  "sports": "Sports",
  "format": "Format",
  "pointAction": "Point",
  "serviceSetup": "Mise en place du service",
  "finalScores": "Scores finals",
  "scoringMode": "Mode de notation",
  "enterScores": "Entrez vos scores",
  "reviewSave": "Review \" save",
  "applyContinue": "Appliquer les scores et continuer en direct",
  "discardContinue": "Abandonner les modifications et continuer en direct",
  "changeService": "Changer de serveur / service",
  "choose": "Choisissez...",
  "rallyWon": "Rallye gagné",
  "discardChanges": "Changements de carte",
  "error_draft_unreadable": "L’ébauche de partitions finales stockée n’a pas pu être lue. Gardez les données et le support de contact de cet appareil avant de le remplacer.",
  "error_draft_action_required": "Révisez les changements de partitions Finales, retirez-les ou continuez à éditer avant de marquer une autre façon.",
  "error_draft_consent_required": "Révisez le score de remplacement et validez pour terminer.",
  "error_draft_revision_changed": "Comparez vos entrées avec le dernier score enregistré et confirmez la comparaison ci-dessous.",
  "error_point_mode_changed": "Confirmez les nouveaux contrôles de points ci-dessous avant d'examiner ce score.",
  "error_point_combination_invalid": "L'avantage doit être associé à 40. Pour le succès, choisissez 40 pour les deux joueurs.",
  "keepDraftAndLeave": "Garder les changements et les congés",
  "discardAndLeave": "Désélectionner les changements et les congés",
  "keepEditing": "Continuez à éditer",
  "draftLeaveNote": "Vos scores entrés n'ont pas été appliqués. Gardez-les à revenir plus tard, les jeter, ou continuer à éditer.",
  "unappliedChanges": "Changements de score non appliqués",
  "reviewAndFinish": "Notation d'examen et session d'arrivée",
  "cardDraftPreserved": "Changements de scores finals non appliqués",
  "draftPending": "Ces changements examinés font l ' objet d ' une file d ' attente et ne peuvent pas être appliqués deux fois.",
  "draftStorageError": "Vos modifications sont toujours là, mais ne peuvent pas être stockées sur cet appareil. Gardez cet écran ouvert et réessayez.",
  "directHistoryDetails": "Cela remplace les progrès de notation dépendants, y compris le jeu ultérieur. Toutes les actions précédentes restent dans l'Histoire.",
  "replacementDetails": "Qu'est-ce qui change ?",
  "reconcileDraft": "J'ai comparé mes entrées avec le dernier score enregistré",
  "draftRevisionChanged": "Le score enregistré a changé pendant que vous éditez. Comparez-le avec vos entrées ci-dessous avant de le remplacer.",
  "useOrdinaryPoints": "Utiliser les points de jeu · points de courant clair",
  "useTieBreakPoints": "Utiliser des points de rupture de cravate · des points de courant clairs",
  "pointModeChanged": "Le dernier set a changé le mode de notation. Choisissez explicitement les commandes de point; cela va effacer les points actuels.",
  "advantage": "Avantage",
  "loveZero": "Aimer / 0",
  "serviceUnknown": "Service non enregistré",
  "interpreting": "Interpréter...",
  "reopenCorrection": "Cette correction rouvre la session. Révisez le score et terminez la session à nouveau pour l'enregistrer.",
  "tieBreakFirstServer": "Qui a servi d'abord dans cette cravate ?",
  "preparingMatch": "Préparer votre match",
  "preparingDetail": "Mettre les courts et les joueurs prêts",
  "restoringMatch": "Restauration de votre match",
  "restoringDetail": "Préparez votre carte de score.",
  "setupProgress": "Mise en place du système d ' ajustement",
  "member": "Membre",
  "session_saved": "Session enregistrée",
  "sessionSaved": "Session enregistrée",
  "sessionPending": "Session en attente de synchronisation",
  "playEnded": "Il n'y a pas de gagnant.",
  "finishSession": "Review \" save",
  "set": "Set",
  "game": "Jeu",
  "points": "Points",
  "unfinishedSegment": "En cours · inachevé",
  "segmentCompleted": "Terminé",
  "addSet": "Ajouter un autre jeu",
  "addGame": "Ajouter un autre jeu",
  "currentPointsOptional": "Points actuels (facultatif)",
  "directHistoryAck": "Remplacer le score enregistré",
  "directEntryReason": "Entrée au tableau de bord",
  "reviewScore": "Review \" save",
  "receivingFirst": "Qui reçoit le premier de l'autre équipe ?",
  "rightCourt": "Joueur sur la droite · équipe",
  "startLive": "Continuer à marquer en direct",
  "operation_direct_score": "Score inscrit",
  "operation_configure_service": "Service confirmé",
  "operation_finish_session": "Session terminée",
  "error_unfinished_segment_must_be_last": "Seul le segment final peut être inachevé. Complétez-le avant d'ajouter un autre.",
  "error_mark_segment_completed": "Ce score complète le segment. Marquez-le terminé, ou corrigez le score.",
  "correctLastRally": "Corrigez le dernier rallye",
  "operation_replace_last_rally": "Dernière course corrigée",
  "conflictStatus": "Examen des besoins",
  "storageStatus": "Examen des besoins",
  "pendingOnline": "Épargne",
  "historyTitle": "Votre Let’s Play",
  "historyIntro": "Les rounds, les jeux et les moments que vous avez partagés.",
  "all": "Tous",
  "filterHistory": "Historique des filtres",
  "historyLoad": "Chargement de votre histoire",
  "historyEmptyTitle": "Votre histoire commence ici.",
  "historyEmpty": "Les activités achevées apparaîtront ici.",
  "more": "Charger plus",
  "manageMoment": "Gérer le moment",
  "photoUnavailable": "Photo non disponible",
  "moment_loadError": "Nous ne pouvions pas ouvrir ce moment d’activité.",
  "moment_imageError": "Choisissez une image JPEG, PNG ou WebP jusqu'à 15 Mo.",
  "moment_discard": "Jetez cette photo ?",
  "moment_offline": "Vous êtes hors ligne. Votre activité est sûre — ajouter ce moment plus tard de l’Histoire.",
  "moment_conflict": "Ce moment a changé sur un autre appareil. Rechargez avant d'essayer à nouveau.",
  "moment_saveError": "Votre photo n’a pas été sauvegardée. Gardez-le ici et essayez à nouveau.",
  "moment_captionError": "La légende ne pouvait pas être enregistrée.",
  "moment_removeConfirm": "Retirer ce moment? L'activité terminée ne sera pas changée.",
  "moment_removeError": "Le moment n'a pas pu être retiré. Rechargez et essayez à nouveau.",
  "moment_opening": "Ouverture du moment",
  "moment_access": "Contrôle de l ' accès aux activités",
  "moment_unavailable": "Moment indisponible",
  "moment_label": "MOMENT D ' ACTIVITÉ",
  "moment_from": "Un moment de cette activité",
  "moment_none": "Aucun moment n'a été capturé.",
  "moment_alt": "moment de l ' activité",
  "moment_your": "VOTRE MOMENT",
  "moment_activityComplete": "COMPLETTE D ' ACTIVITÉ",
  "moment_remember": "Souviens-toi de ça.",
  "moment_capture": "Capturez le moment ?",
  "moment_intro": "Les grands jeux valent la peine de se rappeler.",
  "moment_editCaption": "Modifier le sous-titrage",
  "moment_saveCaption": "Sauvez la captivité",
  "moment_remove": "Supprimer le moment",
  "moment_take": "Prenez la photo.",
  "moment_replace": "Remplacer la photo",
  "moment_choose": "Choisissez la photo",
  "moment_later": "Pas maintenant.",
  "moment_keep": "Gardez celle-là ?",
  "moment_preview": "Aperçu du moment",
  "moment_caption": "Ajouter un sous-titrage (facultatif)",
  "moment_captionExample": "Tonnerre d'été avec Chris",
  "moment_preparing": "Préparer et Enregistrer...",
  "moment_save": "Sauvegarder le moment",
  "moment_another": "Choisissez un autre",
  "error_invalid_segment_score": "Entrez un score de jeu/de jeu valide, ou marquez la dernière ligne non finie. Vérifiez chaque ligne mise en évidence.",
  "error_invalid_point_score": "Utilisez 0, 15, 30, 40 ou avantage. Un jeu fini a besoin d'un résumé de jeu.",
  "error_invalid_game_score": "Saisissez un score d'manche inachevé jusqu'à 6–6 ou enregistrez un manche rempli.",
  "error_invalid_correction": "Entrez les deux scores et choisissez le serveur et la boîte de service.",
  "error_service_information_required": "Choisissez explicitement le prochain serveur et la boîte de service.",
  "error_invalid_service_box": "La boîte de service ne correspond pas à ce score et à ce serveur. Vérifiez leur position de cour.",
  "error_invalid_service_order": "Vérifiez l'ordre de service. Les équipes de tennis et de padel doivent alterner.",
  "error_server_number_required": "Choisissez le serveur 1 ou 2 pour les doubles, ou le serveur 1 pour les singles.",
  "error_court_positions_required": "Confirmez le joueur de droit de chaque équipe avant de postuler.",
  "error_invalid_court_positions": "Le serveur sélectionné n'est pas dans la boîte de service sélectionnée. Vérifiez les positions du court.",
  "error_terminal_score_requires_segment": "Ce score termine un jeu ou un jeu. Utilisez un résumé de segment terminé.",
  "error_summary_would_rewrite_games": "Le score final ne peut pas effacer les jeux déjà enregistrés. Correction des jeux actuels en premier ou examen des segments historiques.",
  "error_dependent_history_requires_resolution": "Confirmer que tous les segments ultérieurs et les progrès actuels seront supprimés.",
  "error_queue_capacity_reached": "La queue de l'appareil est pleine. Reconnectez pour enregistrer avant d'enregistrer plus d'actions.",
  "error_court_not_available_for_sport": "Ce court n'est plus disponible pour ce sport. Choisissez une autre cour.",
  "error_format_not_supported_by_court": "Choisissez un format supporté par cette cour ou sélectionnez une autre cour.",
  "error_duplicate_participant": "Chaque joueur doit apparaître une fois. Vérifiez les équipes et les noms d'invités.",
  "error_reason_required": "Entrez une raison pour que la correction soit claire dans l'histoire du match.",
  "tieBreak": "Cravate.",
  "currentGames": "Jeux actuels (réglages points courants)",
  "operation_correct_games": "Résumé des jeux en cours",
  "court": "Court",
  "match": "Match",
  "players": "Joueurs",
  "review": "Examen",
  "where": "Où on joue ?",
  "how": "Comment on joue ?",
  "who": "Qui joue ?",
  "ready": "Prêt à jouer ?",
  "back": "Retour",
  "next": "Continuer",
  "retry": "Réessayer",
  "loading": "Chargez votre match...",
  "error": "Nous ne pouvions pas remplir cette demande. Vérifiez votre connexion et essayez à nouveau.",
  "noCourts": "Aucun court approprié n'est configuré. Contactez le club pour configurer un court pour ce sport.",
  "noReservation": "Le démarrage d'une carte de score ne réserve pas un court ou ne facture pas votre compte.",
  "indoor": "Intérieur",
  "outdoor": "Extérieur",
  "singles": "Célibataires",
  "doubles": "Doubles",
  "adjust": "Ajuster la notation",
  "start": "Commencer le match",
  "starting": "À partir de...",
  "edit": "Modifier",
  "resumeMatches": "Continuez à jouer",
  "recent": "Acteurs récents",
  "search": "Trouvez un membre du club",
  "noResults": "Aucun membre correspondant",
  "guest": "Nom de l'invité",
  "addGuest": "Ajouter un invité",
  "remove": "Retirer",
  "move": "Déplacer vers une autre équipe",
  "team": "Équipe",
  "youScorer": "Vous êtes le marqueur. D'autres participants peuvent voir ce match.",
  "server": "Serveur",
  "firstServer": "Qui sert d'abord ?",
  "order": "Ordonnance de service",
  "initialBox": "Boîte de service initiale",
  "left": "Gauche",
  "right": "D'accord.",
  "requiredPlayers": "Ajoutez les joueurs requis et assignez des équipes égales.",
  "saved": "enregistrés",
  "saving": "Épargne",
  "pending": "Hors ligne",
  "conflict": "Ce match a changé sur un autre appareil. Vos actions en attente sont préservées.",
  "export": "Télécharger les actions en attente",
  "useServer": "Garder la partition du serveur et jeter les actions en attente",
  "discardConfirm": "J'ai examiné la partition du serveur et je veux jeter ces actions en attente.",
  "storageError": "Le stockage des appareils n'est pas disponible. Gardez cet écran ouvert et reconnectez-vous pour économiser. Télécharger les actions en attente avant de partir.",
  "card": "Scores finals",
  "rally": "Rallye gagné",
  "point": "Point gagné",
  "undo": "Impasse",
  "voice": "Voix",
  "pause": "Pause",
  "resume": "Consommation",
  "paused": "Temps de match",
  "landscape": "Paysage",
  "portrait": "Portrait",
  "rotate": "Faites pivoter votre appareil pour une vue plus large sur la cour. La serrure de rotation de l'appareil peut devoir être éteinte.",
  "swap": "Panneaux d ' affichage Swap",
  "sets": "manches",
  "games": "Jeux",
  "serving": "Desservant",
  "boxRequired": "Choisissez la boîte de service avant le prochain rallye.",
  "correct": "Correction / entrée rapide",
  "preview": "Note de l ' examen",
  "apply": "Confirmer le changement",
  "cancel": "Annuler",
  "before": "Avant",
  "after": "Après.",
  "reason": "Raison de la correction",
  "current": "Points actuels",
  "awardGame": "Jeu en cours de remise des prix (sommaire)",
  "summary": "Enregistrement terminé set/game",
  "historical": "Remplacer un segment antérieur",
  "summaryNote": "L'entrée sommaire enregistre le score sans inventer les rallyes. Les statistiques de points ne sont pas disponibles pour les segments sommaires.",
  "discardFollowing": "Jetez tous les segments ultérieurs et les progrès actuels après ce segment",
  "segment": "Débat",
  "history": "Actions enregistrées",
  "summaryOnly": "Résumé",
  "rallyHistory": "Rallye",
  "confirmResult": "Confirmer le résultat final",
  "resultReady": "Un gagnant — prêt à confirmer?",
  "completed": "Match complet",
  "retired": "Retraite",
  "abandoned": "Abandonné",
  "unfinished": "Non classé",
  "in_progress": "En cours",
  "awaiting_confirmation": "Résultat en attente de confirmation",
  "winner": "Gagnant",
  "endEarly": "Match final tôt",
  "retire": "Retraite",
  "abandon": "Abandon",
  "finishUnfinished": "Sauvegarder comme inachevé",
  "earlyNote": "Cela préserve le score sans déclarer une victoire terminée.",
  "scorecard": "Voir le tableau des résultats",
  "done": "Retour à Let’s Play",
  "moment": "Ajouter un instant",
  "share": "Résultat du partage",
  "shareNote": "Partager seulement le sport et score. Les noms des joueurs, les invités et les liens de médias privés sont exclus.",
  "listen": "Score record",
  "stop": "Arrêter d'enregistrer",
  "transcript": "Transcription originale",
  "interpret": "Notation d ' interprétation",
  "voiceReview": "Notation vocale",
  "voiceFailure": "La voix n'est pas disponible. Vous pouvez continuer à marquer manuellement ou entrer dans la transcription ci-dessous.",
  "clarify": "Plus d ' informations nécessaires",
  "repair": "Réparation de transcription suggérée",
  "ackRepair": "Je reconnais cette réparation de transcription.",
  "staleVoice": "Le match ou l'affichage a changé. Interpréter à nouveau avant de postuler.",
  "deuce": "Égalité",
  "gamePoint": "Point de jeu",
  "matchPoint": "Point de correspondance",
  "readOnly": "Vous pouvez voir ce match. Seul son créateur peut marquer.",
  "source": "Source de règles",
  "unknown": "Choisissez explicitement",
  "serverNumber": "Numéro de serveur",
  "positions": "Lecteur de droit",
  "savedMatches": "Vos allumettes",
  "noMatches": "Vos matchs apparaîtront ici.",
  "tennis": "Tennis",
  "padel": "Padel",
  "pickleball": "Pickle-ball",
  "squash": "Squash",
  "tennis_one_set": "Un manche · avantage · rupture de cravate à 6–6",
  "tennis_best_of_three": "Best of 3 sets · advantage · tie-break à 6–6",
  "padel_advantage": "Meilleur de 3 sets · avantage (option FIP 1)",
  "pickleball_one_game": "Un jeu à 11 · side-out · win by 2",
  "pickleball_best_of_three": "Le meilleur de 3 à 11 · side-out · win by 2",
  "squash_best_of_three": "Meilleur de 3 à 11 · point-a-rally · gagner de 2",
  "squash_best_of_five": "Meilleur de 5 à 11 · point-a-rally · gagner de 2",
  "operation_rally": "Rallye gagné",
  "operation_undo": "Impasse",
  "operation_correct_current": "Notation actuelle correcte",
  "operation_award_game": "Résumé",
  "operation_summary_segment": "Résumé du débat",
  "operation_replace_segment": "Correction historique; progrès ultérieurs supprimés",
  "operation_pause": "Pause",
  "operation_resume": "Reprise",
  "operation_confirm_result": "Résultat confirmé",
  "operation_service_box": "Boîte de service sélectionnée",
  "operation_retire": "Retraite",
  "operation_abandon": "Abandonné",
  "operation_unfinished": "enregistré inachevé",
  "moreOptions": "Autres options",
  "backToScores": "Retour aux scores",
  "pointsForUnfinished": "Seulement enregistrer les points actuels pour un manche inachevé.",
  "error_completed_segment_has_points": "Les points actuels restent de la notation en direct. Gardez-les dans un nouvel manche inachevé, ou les effacez explicitement avant d'enregistrer des manches terminés.",
  "clearStalePoints": "Points courants clairs",
  "retainUnfinishedPoints": "Gardez des points dans un manche inachevé",
  "resultHeading": "Un pour l'histoire.",
  "sessionWinner": "Résultat de la séance",
  "playEndedEarly": "Pièce s'est terminée tôt",
  "runnerUp": "Finaliste",
  "continue": "Continuer",
  "backToResult": "Retour au résultat",
  "completionAttention": "Vos scores en attente sont conservés.",
  "savedOnDevice": "Sauvegardé sur ce dispositif · en attente de synchronisation",
  "serverConfirmed": "Confirmé par le serveur",
  "proposedScore": "Score final",
  "finishNote": "Cela sauve les scores et les fins de jeu.",
  "replaceAndFinish": "Remplacer les scores & finition",
  "saveAndFinish": "Enregistrer et terminer",
  "replaceAndContinue": "Remplacer les scores & continuer",
  "levelOnSets": "Niveau des manches",
  "levelOnGames": "Niveau sur les jeux",
  "reviewChanged": "Les scores ont changé. Annuler cet avis, comparez à nouveau le dernier score et l'avis.",
  "preparingReview": "Examen préliminaire...",
  "reviewPreparationError": "Nous ne pouvions pas préparer cette critique vocale. Annuler et réexaminer; vos scores sont conservés."
}
